/* tslint:disable */
/* eslint-disable */
/**
 * True one Services API
 * True one service for form Builder
 *
 * The version of the OpenAPI document: 4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
/**
 * 
 * @export
 * @interface Tool
 */
export interface Tool {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    type?: string;
    /**
     * 
     */
    name?: string;
    /**
     * 
     */
    description?: string;
    /**
     * 
     */
    partNumber?: string;
    /**
     * 
     */
    createdAt?: Date;
    /**
     * 
     */
    updatedAt?: Date;
    /**
     * 
     */
    active?: boolean;
}

/**
 * Check if a given object implements the Tool interface.
 */
export function instanceOfTool(value: object): value is Tool {
    return true;
}

export function ToolFromJSON(json: any): Tool {
    return ToolFromJSONTyped(json, false);
}

export function ToolFromJSONTyped(json: any, ignoreDiscriminator: boolean): Tool {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'type': json['type'] == null ? undefined : json['type'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'partNumber': json['partNumber'] == null ? undefined : json['partNumber'],
        'createdAt': json['createdAt'] == null ? undefined : (parseDateTime(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (parseDateTime(json['updatedAt'])),
        'active': json['active'] == null ? undefined : json['active'],
    };
}

export function ToolToJSON(json: any): Tool {
    return ToolToJSONTyped(json, false);
}

export function ToolToJSONTyped(value?: Tool | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'type': value['type'],
        'name': value['name'],
        'description': value['description'],
        'partNumber': value['partNumber'],
        'createdAt': value['createdAt'] == null ? value['createdAt'] : serializeDateTime(value['createdAt']),
        'updatedAt': value['updatedAt'] == null ? value['updatedAt'] : serializeDateTime(value['updatedAt']),
        'active': value['active'],
    };
}

